import { render } from "./MobileBottomBar.vue?vue&type=template&id=43abd4e3&scoped=true"
import script from "./MobileBottomBar.vue?vue&type=script&lang=js"
export * from "./MobileBottomBar.vue?vue&type=script&lang=js"

import "./MobileBottomBar.vue?vue&type=style&index=0&id=43abd4e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43abd4e3"]])

export default __exports__